import {
  EstimateFieldFilter,
  EstimateFieldFilterOperationType,
  EstimateRelativeDirection,
} from 'module/types/filter-field/filter/estimate';
import { snakeCase } from 'lodash';
import { FormattedMessage } from 'react-intl';

export const format = (filter: EstimateFieldFilter) => {
  return (
    <FormattedMessage
      id={`task_list.filters.messages.${snakeCase(
        filter.field.type,
      )}.${snakeCase(EstimateFieldFilterOperationType[filter.type])}`}
      values={{
        days: (filter as EstimateFieldFilter).days ?? 0,
        direction: (
          (filter as EstimateFieldFilter).direction ??
          EstimateRelativeDirection.Early
        ).toLowerCase(),
      }}
    />
  );
};
